import AiProvider from "./AiProvider";
import { lazyAiComponent } from "./lazyAiComponent";

const AiSummaryBase = lazyAiComponent("AiSummary");

const AiSummary = ({ allowAddAI, leadPersonUuid, phoneStatus, variant }) => (
  <AiProvider>
    <AiSummaryBase
      allowAddAI={allowAddAI}
      leadPersonUuid={leadPersonUuid}
      phoneStatus={phoneStatus}
      variant={variant}
    />
  </AiProvider>
);

export default AiSummary;
